// Imports
import React from "react"
import { Helmet as Container } from "react-helmet"

import siteData from "../data/site-data"

const Helmet = ({ title, description, category, keywords }) => {
    return (
        <Container>
            <title>
                {title} | {siteData.name}
            </title>

            <link rel="icon" href={`/images/${siteData.favicon}`} />
            <meta content="IE=edge" http-equiv="X-UA-Compatible" />
            <meta
                content="width=device-width, initial-scale=1"
                name="viewport"
            />
            <meta
                name="description"
                content={
                    description
                        ? description
                        : category
                        ? `${title} component for Fajny CSS`
                        : siteData.description
                }
            />
            <meta
                name="keywords"
                content={[
                    ...siteData.keywords,
                    title !== "Homepage" ? title.toLowerCase() : "",
                    keywords,
                ]}
            />
            <meta name="author" content={siteData.author} />
            <meta property="og:title" content={title} />
            <meta property="og:type" content={siteData.type} />
            <meta property="og:image" content={siteData.coverOg} />
            <meta property="og:site_name" content={siteData.name} />
            <meta property="og:locale" content={siteData.lang} />

            <html lang={siteData.lang} />
        </Container>
    )
}

export default Helmet
